import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import {
  DataContextBuilder,
  IDataContext,
  ElderTableComponent,
  ElderPaneComponent,
  ElderBasicPaneLayoutComponent,
} from '@elderbyte/ngx-starter'
import { Router } from '@angular/router'
import { NumberSequenceService } from '../number-sequence.service'
import { NumberSequence } from '../number-sequence'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-number-sequence-browser',
  templateUrl: './number-sequence-browser.component.html',
  styleUrls: ['./number-sequence-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class NumberSequenceBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<NumberSequence>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const sequenceService = inject(NumberSequenceService)

    this.data = DataContextBuilder.start<NumberSequence>()
      .pageSize(15)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(sequenceService)
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onItemClick(sequence: NumberSequence): void {
    this.router.navigate([{ outlets: { side: ['number-sequences', sequence.id] } }], {
      preserveFragment: true,
    })
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  // private save(): void {
  //   this.sequenceService.update(this.sequence).subscribe({
  //       next: _ => this.toastService.info('messages.persisting_successful'),
  //       error: err => this.toastService.error('messages.saving_failed', err)
  //     }
  //   );
  // }
  //
  // private delete(): void {
  //   this.sequenceService.delete(this.sequence).subscribe({
  //       next: _ => this.toastService.info('messages.deleting_successful'),
  //       error: err => this.toastService.error('messages.deleting_failed', err)
  //     }
  //   );
  // }
  //
  // public patchNextNumber(): void {
  //   const patch = new NumberSequencePatch(this.sequence.id);
  //   patch.nextNumber = this.sequence.nextNumber;
  //   this.sequenceService.patch(patch).subscribe(
  //     updated => this.sequence = updated,
  //     err => this.toastService.error('Failed to update NextNumber!', err)
  //   )
  // }
}
